<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'userreservations'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ $_locale('reservations') }}
        </h3>
    </div>
    <div class="modal-body reservation-modal userteetime-modal">
        <div class="panel-body" style="padding: 0;">
            <wn-table-pages 
                :items="reservationsByOrderId" 
                :perPage="15"
                :pagingOptions="[15, 25, -1]">
                <template #head>
                    <th style="min-width: 65px;"></th>
                    <th>{{ $_locale('reservation') }}</th>
                    <th>{{ $_locale('order number') }}</th>
                    <th>{{ $_locale('created') }}</th>
                    <th>{{ $_locale('orderer') }}</th>
                    <th>{{ $_locale('recurring reservation') }}</th>
                </template>
                <template v-slot="{ item: row }">
                    <!--
                    <tr :key="row.orderId">
                        <td>
                            <div style="padding: 10px 0;display:flex;">
                                
                            </div>
                        </td>
                        <td>
                        </td>
                        <td style="text-align:right;">
                            <a :href="orderLinkUrl(row.orderId, row.hash)" target="_blank">
                                {{ row.orderId }}
                            </a>
                        </td>
                        <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.dateCreated) }}</td>
                        <td>{{ row.reserverFirstName }} {{ row.reserverFamilyName }}</td>
                    </tr>
                    -->
                    <tr :class="{ 'order-even': row.evenRow, 'order-odd': !row.evenRow }"
                        v-for="reservation in row.reservationTimes" 
                        :key="reservation.reservationTimeId">
                        <td>
                            <div style="padding: 10px 0;display:flex;">
                                <!--
                                <button class="btn btn-xs btn-success" 
                                    v-if="[2].indexOf(row.status) > -1"
                                    @click="confirmTeeTime(row.reservationTimeId)"
                                    :disabled="!row.inFuture">
                                    <i class="glyphicon glyphicon-ok"></i>
                                    <span>{{ $_locale('confirm') }}</span>
                                </button>
                                <button class="btn btn-xs btn-default" 
                                    v-if="[3].indexOf(row.status) > -1"
                                    style="min-height: unset;"
                                    :disabled="true">
                                    <i class="glyphicon glyphicon-ok"></i>
                                    <span>{{ $_locale('confirmed') }}</span>
                                </button>
                                    
                                -->
                                <button class="btn btn-xs btn-danger" 
                                    style="margin-left: 7px;"
                                    v-if="[2,3].indexOf(reservation.status) > -1"
                                    @click="deactivateReservationTime(reservation.reservationTimeId)"
                                    :disabled="!reservation.inFuture">
                                    <i class="glyphicon glyphicon-remove"></i>
                                    <span>{{ $_locale('cancel') }}</span>
                                </button>
                                <span class="badge badge-info" style="margin-left: 7px;"
                                    v-if="reservation.isSold">{{ $_locale('sold') }}</span>
                                <span class="badge badge-info" style="margin-left: 7px;"
                                    v-if="reservation.isOnSale">{{ $_locale('for sale') }}</span>
                            </div>
                        </td>
                        <td>
                            {{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, reservation.dateTimeStart) }}
                            -
                            {{ $_formatDateTime($_dateFormat.DATETIME_HI, reservation.dateTimeEnd) }}
                        </td>
                        <td style="text-align:right;">
                            <a :href="orderLinkUrl(reservation.orderId, reservation.hash)" target="_blank">
                                {{ reservation.orderId }}
                            </a>
                        </td>
                        <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, reservation.dateCreated) }}</td>
                        <td>{{ reservation.reserverFirstName }} {{ reservation.reserverFamilyName }}</td>
                        <td>
                            <span class="badge badge-success"
                                v-if="reservation.label === 'res_recurring'">
                                <i class="glyphicon glyphicon-ok"></i>
                            </span>
                        </td>
                    </tr>
                </template>
            </wn-table-pages>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" 
            @click="$store.commit('common/setModal', null)">
            {{ $_locale('close') }}
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            modalIsOpen: 'common/modalIsOpen',
            modalName: 'common/modalName',
            adminMode: 'common/adminMode',
            orderLinkUrl: 'ecom/orderLinkUrl',
            userReservations: 'reservations/userReservations',
        }),
        reservationsByOrderId() {
            const orders = {}

            this.userReservations.forEach(row => {
                const { 
                    orderId,
                } = row;

                if (typeof orders[row.orderId] === 'object') {
                    orders[row.orderId].reservationTimes.push(row)
                } else {
                    orders[row.orderId] = {
                        orderId,
                        reservationTimes: [row]
                    }
                }
            })

            return Object.keys(orders)
                .map((key, i) => {
                    const order = orders[key];
                    order.evenRow = i % 2 == 0;
                    return order;
                })
                .sort((a, b) => {
                    const startTime_a = a.dateTimeStart;
                    const startTime_b = b.dateTimeStart;

                    return moment(startTime_a) < moment(startTime_b) ? 1 : -1;
                });
        }
    },
    watch: {
        modalIsOpen(val) {
            if (this.modalName !== 'userreservations') return;
            
            if (val) {
                this.$store.dispatch('reservations/getUserReservations');
            } else {
                
            }
        },
    },
    methods: {
        /*
        confirmTeeTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('confirm tee time').ucfirst() + '?',
                text: '',
                type: 'success',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    EcomService.confirmTeeTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                this.$store.dispatch('golf/getUserGolfReservations');
                            } else {
                                this.$store.commit('common/setModal', null);
                                showErrorDialog(data.message, true, false, true);
                            }
                        })
                }
            })
        },
        */
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('common/setModal', null);
                    
                    EcomService.deactivateReservationTime(reservationTimeId)
                    .then((response) => {
                        const { data } = response;
                        
                        if (data.success) {
                            this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                        } else {
                            this.$_swal({ icon: 'error', title: data.message })
                        }
                    })
                }
            })
        },
    },
    mounted() {
    }
}
</script>